import { render, staticRenderFns } from "./BulkApproval.vue?vue&type=template&id=292e8ab4&"
import script from "./BulkApproval.vue?vue&type=script&lang=js&"
export * from "./BulkApproval.vue?vue&type=script&lang=js&"
import style0 from "./BulkApproval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports